import { render, staticRenderFns } from "./CustomerOrdersAdd.vue?vue&type=template&id=00b87c36&scoped=true&"
import script from "./CustomerOrdersAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerOrdersAdd.vue?vue&type=style&index=1&id=00b87c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b87c36",
  null
  
)

export default component.exports